import { Cta, Label } from 'apps/auth/scripts/components';

import messages from './messages.json';

interface Props {
  onClick?: () => void;
}

const FormSubheader = ({ onClick }: Props) => {
  return (
    <>
      <Label value={messages.subheaderLabel} />
      <Cta label={messages.subheaderButton} onClick={onClick} to={'/signup'} />
    </>
  );
};

FormSubheader.displayName = 'FormSubheader';

export default FormSubheader;
